import { trackEvent } from './tracking';

// Types
import { CalendarMeeting } from 'Shared/types/CalendarMeeting.type';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  calendarMeeting: CalendarMeeting;
};

export const useCalendarMeetingsTracking = ({ calendarMeeting }: Props) => {
  const { id } = useCurrentUser();
  const { appId } = useApp();

  const numberOfAttendees = calendarMeeting.attendees.length || 0;
  const hasVideoLink = Boolean(calendarMeeting.conferenceUrl);
  const attachedToWorkspace = Boolean(calendarMeeting.workspaceId);

  const track = ({ eventName, properties = {} }) => {
    const propertiesToSend = {
      product_feature: 'Calendar Meeting',
      user: id,
      app_id: appId,
      number_of_attendees: numberOfAttendees,
      hasVideoLink,
      attachedToWorkspace,
      ...properties,
    };

    trackEvent(eventName, propertiesToSend);
  };

  const trackClickedCalendarMeeting = () => {
    track({
      eventName: 'Clicked Calendar Event',
    });
  };

  const trackClickedJoinVideoLink = () => {
    track({
      eventName: 'Clicked Join Video Meeting',
    });
  };

  const trackClickedJoinMeetingMode = () => {
    track({
      eventName: 'Clicked Join Meeting Mode',
    });
  };

  const trackViewInCalendar = () => {
    track({
      eventName: 'Clicked to view in calendar',
    });
  };

  const trackViewWorkspace = () => {
    track({
      eventName: 'Clicked to view workspace',
    });
  };

  const trackCickedToCreateWorkspace = () => {
    track({
      eventName: 'Clicked to create Workspace',
    });
  };

  return {
    trackClickedCalendarMeeting,
    trackClickedJoinVideoLink,
    trackClickedJoinMeetingMode,
    trackViewInCalendar,
    trackViewWorkspace,
    trackCickedToCreateWorkspace,
  };
};
